import { api } from '../../axios.instance';

export const exportAlerts = () => {
  return api.get('alerts/export', { responseType: 'blob' });
};
